import Vue from 'vue';
const path = require('path');
const components = require.context('.', true, /\.vue$/);
components.keys().forEach((key) => {
  const name = path.basename(key, '.vue');
  Vue.component(name, components(key).default || components(key));
});
